export default __webpack_public_path__ + "static/media/no-meds-orders.5b2c5cae.png";